const Slider = ({ orientation = 'horizontal' }) => {
  return {
    chevronOffset: null,

    slides: new Set(),

    isStart() {
      return this.slides.has(0);
    },

    isEnd() {
      const count = this.$refs.slider.querySelectorAll('li').length;
      return this.slides.has(count - 1);
    },

    orientation: null,

    skip: 1,

    init() {
      this.orientation = orientation;
      this.$nextTick(() => this.getChevronOffset());
    },

    Slide(index) {
      return {
        'x-intersect:enter'() {
          this.slides.add(index - 1);
          this.$el.removeAttribute('tabindex');
        },
        'x-intersect:leave'() {
          this.slides.delete(index - 1);
          this.$el.setAttribute('tabindex', '-1');
        },
      };
    },

    getChevronOffset() {
      switch (this.orientation) {
        case 'vertical': {
          const image = this.$refs.slider.querySelector('li:first-of-type img');
          if (image) {
            this.chevronOffset = image.clientWidth / 2 - 20;
          }
          break;
        }

        case 'horizontal': {
          const image = this.$refs.slider.querySelector('li:first-of-type img');
          if (image) {
            this.chevronOffset = image.clientHeight / 2 - 20;
          }
          break;
        }
      }
    },

    handleNext() {
      switch (this.orientation) {
        case 'vertical': {
          const ref = this.$refs.slider;
          const currentTop = ref.scrollTop;
          const [ix] = this.slides;
          const currentRect = ref.children[ix].getBoundingClientRect();
          const nextRect = ref.children[ix + 1].getBoundingClientRect();
          const offset = currentRect.height + (nextRect.top - currentRect.bottom);
          const nextTop = currentTop + offset;

          ref.scrollTo({
            top: nextTop,
            behavior: 'smooth',
          });

          break;
        }

        case 'horizontal': {
          const ref = this.$refs.slider;
          const currentLeft = ref.scrollLeft;
          const [ix] = this.slides;
          const currentRect = ref.children[ix].getBoundingClientRect();
          const offset = currentRect.width;
          const nextLeft = currentLeft + offset;

          ref.scrollTo({
            left: nextLeft,
            behavior: 'smooth',
          });

          break;
        }
      }
    },

    handlePrev() {
      switch (this.orientation) {
        case 'vertical': {
          const ref = this.$refs.slider;
          const currentTop = ref.scrollTop;
          const [ix] = this.slides;
          const prevRect = ref.children[ix - 1].getBoundingClientRect();
          const offset = prevRect.height;
          const nextTop = currentTop - offset;

          ref.scrollTo({
            top: nextTop,
            behavior: 'smooth',
          });

          break;
        }

        case 'horizontal': {
          const ref = this.$refs.slider;
          const currentLeft = ref.scrollLeft;
          const [ix] = this.slides;
          const prevRect = ref.children[ix - 1].getBoundingClientRect();
          const offset = prevRect.width;
          const nextLeft = currentLeft - offset;

          ref.scrollTo({
            left: nextLeft,
            behavior: 'smooth',
          });

          break;
        }
      }
    },
  };
};

export default Slider;
